import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import './SwipeTour.css';

interface STP {
    onComplete: () => void;
    styles?: any;
    skipSwipe?: boolean; // <-- Новий пропс
}

const SwipeTour: FC<STP> = ({ onComplete, styles, skipSwipe }) => {
    const [tourStep, setTourStep] = useState(0);
    const { t } = useTranslation();

    const getTourMessages = () => {
        const messages = [
            {
                message: `${t('jackpot.ticketSummary.swipeLeftMRFTHint')}`,
                style: {
                    opacity: .8,
                    top: "60%",
                    left: "10%",
                    backgroundColor: styles.colors.blockBgColor,
                    color: styles.colors.fontColor,
                    border: `2px solid ${styles.colors.buttonFontColor}`,
                },
                class: 'left-swipe'
            },
            {
                message: `${t('jackpot.ticketSummary.swipeRightMRFTHint')}`,
                style: {
                    opacity: .8,
                    top: "60%",
                    right: "10%",
                    backgroundColor: styles.colors.blockBgColor,
                    color: styles.colors.fontColor,
                    border: `2px solid ${styles.colors.buttonFontColor}`,
                },
                class: 'right-swipe'
            },
            {
                message: `${t('jackpot.ticketSummary.swipeDownMRFTHint')}`,
                style: {
                    opacity: .8,
                    top: "60%",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: styles.colors.blockBgColor,
                    color: styles.colors.fontColor,
                    border: `2px solid ${styles.colors.buttonFontColor}`,
                },
                class: 'down-swipe'
            },
        ];

        // Якщо skipSwipe === true, додаємо ще один крок
        if (skipSwipe) {
            messages.push({
                message: `${t('jackpot.ticketSummary.swipeUpHint')}`, // Переконайтесь, що ключ перекладу існує
                style: {
                    opacity: .8,
                    top: "40%", // Трохи вище для кращої візуалізації
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: styles.colors.blockBgColor,
                    color: styles.colors.fontColor,
                    border: `2px solid ${styles.colors.buttonFontColor}`,
                },
                class: 'up-swipe'
            });
        }

        return messages;
    };

    const tourMessages = getTourMessages();

    const handleNext = () => {
        if (tourStep < tourMessages.length - 1) {
            setTourStep(tourStep + 1);
        } else {
            handleComplete();
        }
    };

    const handleComplete = () => {
        setTourStep(-1);
        localStorage.setItem("swipeTourCompleted", "true");
        onComplete();
    };

    return (
        <>
            {tourStep >= 0 && (
                <div className="tour-overlay">
                    <div className='tour-message' style={tourMessages[tourStep].style}>
                        <p className='tour-message-content'>
                            <div className={`${tourMessages[tourStep].class}`} />
                        </p>
                        <p
                            style={{
                                fontFamily: styles.fonts.titleFontFamily,
                                color: styles.colors.fontColor,
                            }}
                        >
                            {tourMessages[tourStep].message}
                        </p>
                        <button
                            onClick={handleNext}
                            style={{
                                backgroundColor: styles.colors.buttonBGColor,
                                color: styles.colors.buttonFontColor,
                                fontWeight: 'bold'
                            }}
                        >
                            {tourStep === tourMessages.length - 1 ? `${t('jackpot.ticketSummary.goToMarketBTN')}` : `${t('jackpot.ticketSummary.gotItBTN')}`}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default SwipeTour;